/*
 Copyright (c) 2012-2018 Open Lab
 Written by Roberto Bicchierai and Silvia Chelazzi http://roberto.open-lab.com
 Permission is hereby granted, free of charge, to any person obtaining
 a copy of this software and associated documentation files (the
 "Software"), to deal in the Software without restriction, including
 without limitation the rights to use, copy, modify, merge, publish,
 distribute, sublicense, and/or sell copies of the Software, and to
 permit persons to whom the Software is furnished to do so, subject to
 the following conditions:

 The above copyright notice and this permission notice shall be
 included in all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.


 todo For compatibility with IE and SVGElements.getElementsByClassName not implemented changed every find starting from SVGElement (the other works fine)
 .find(".classname"))  -> .find("[class*=classname])
 */
window.Ganttalendar=function(startMillis, endMillis, master, minGanttSize) {
  this.master = master; // is the a GantEditor instance
  this.element; // is the jquery element containing gantt

  this.svg; // instance of svg object containing gantt
  this.tasksGroup; //instance of svg group containing tasks
  this.linksGroup; //instance of svg group containing links

  this.minGanttSize = minGanttSize;
  this.includeToday = false; //when true today is always visible. If false boundaries comes from tasks periods
  this.showCriticalPath = false; //when true critical path is highlighted

  this.initZoomlevels(); // initialite the zoom level definitions

  this.originalStartMillis=startMillis;
  this.originalEndMillis=endMillis;
  this.gridChanged=true; //witness for boundaries changed. Force to redraw gantt grid
  this.element = this.createGanttGrid(); // fake

  this.linkOnProgress = false; //set to true when creating a new link

  this.taskHeight=20;
  this.resizeZoneWidth=5;
  this.taskVertOffset = (this.master.rowHeight - this.taskHeight) / 2;
}


Ganttalendar.prototype.zoomGantt = function (isPlus,zoom) {
  var centerMillis=this.getCenterMillis();
  if(zoom){
    if(this.zoom!=zoom){
      this.zoom = zoom;
      this.gridChanged=true;
      this.redraw();
      this.goToMillis(centerMillis);
    }
  }else{
    var curLevel = this.zoom;
    var pos = this.zoomLevels.indexOf(curLevel + "");
    var newPos = pos;
    if (isPlus) {
      newPos = pos <= 0 ? 0 : pos - 1;
    } else {
      newPos = pos >= this.zoomLevels.length - 1 ? this.zoomLevels.length - 1 : pos + 1;
    }
    if (newPos != pos) {
      curLevel = this.zoomLevels[newPos];
      this.gridChanged=true;
      this.zoom = curLevel;
  
      this.redraw();
      this.goToMillis(centerMillis);
    }
  }
};


Ganttalendar.prototype.createHeadCell=function(level,zoomDrawer,rowCtx,lbl, span, additionalClass,start, end) {
  var x = (start.getTime() - self.startMillis)* zoomDrawer.computedScaleX;
  var th = $("<th>").html(lbl).attr("colSpan", span);
  if (level>1) { //set width on second level only
    var w = (end.getTime() - start.getTime()) * zoomDrawer.computedScaleX;
    th.width(w);
  }
  if (additionalClass)
    th.addClass(additionalClass);
  rowCtx.append(th);
};

Ganttalendar.prototype.createBodyCell=function(zoomDrawer,tr,span, isEnd, additionalClass) {
  var ret = $("<td>").html("").attr("colSpan", span).addClass("ganttBodyCell");
  if (isEnd)
    ret.addClass("end");
  if (additionalClass)
    ret.addClass(additionalClass);
  tr.append(ret);
};

//判断是否时间边界变更了
Ganttalendar.prototype.isChangedBoundary = function () {
  var self = this;
  var zoomDrawer=self.zoomDrawers[self.zoom] || self.zoomDrawers[self.zoomLevels[self.zoomLevels.length-1]];
  var adjustedStartDate= new Date(this.originalStartMillis);
  var adjustedEndDate=new Date(this.originalEndMillis);
  zoomDrawer.adjustDates(adjustedStartDate,adjustedEndDate);
  var start = new Date(adjustedStartDate).setHours(0, 0, 0, 0); //real dimension of gantt
  var end = new Date(adjustedEndDate).setHours(23, 59, 59, 999);
  return start!=self.startMillis||end!=self.endMillis;
}


Ganttalendar.prototype.createGanttGrid = function () {
  var self = this;
  var zoomDrawer=self.zoomDrawers[self.zoom] || self.zoomDrawers[self.zoomLevels[self.zoomLevels.length-1]];

  //get best dimension for gantt
  var adjustedStartDate= new Date(this.originalStartMillis);
  var adjustedEndDate=new Date(this.originalEndMillis);
  zoomDrawer.adjustDates(adjustedStartDate,adjustedEndDate);

  self.startMillis = new Date(adjustedStartDate).setHours(0, 0, 0, 0); //real dimension of gantt
  self.endMillis = new Date(adjustedEndDate).setHours(23, 59, 59, 999);

    //this is computed by hand in order to optimize cell size
  var computedTableWidth= (self.endMillis - self.startMillis) * zoomDrawer.computedScaleX;

    //set a minimal width
    computedTableWidth = Math.max(computedTableWidth, self.minGanttSize);
    var table = $("<table cellspacing=0 cellpadding=0>");

    //loop for header1
  var start = new Date(self.startMillis);
    var tr1 = $("<tr>").addClass("ganttHead1");
  while (start.getTime() <= self.endMillis) {
      zoomDrawer.row1(start,tr1);
  }
    //loop for header2  e tbody
  start = new Date(self.startMillis);
  var tr2 = $("<tr>").addClass("ganttHead2");
  var trBody = $("<tr>").addClass("ganttBody");
  var rowNum=0;
  while (start.getTime() <= self.endMillis) {
    zoomDrawer.row2(start,tr2,trBody);
    rowNum++;
  }

  if(self.master.ganttStore.timelinekey=='1M'){
    computedTableWidth=rowNum*20;//20像素一天
  }

  table.append(tr1).append(tr2);   // removed as on FF there are rounding issues  //.css({width:computedTableWidth});

    var head = table.clone().addClass("ganttFixHead");

    table.find('.ganttHead1').css('visibility','hidden');
    table.find('.ganttHead2').css('visibility','hidden');


    table.append(trBody).addClass("ganttTable");


    var height = self.master.editor.element.height();
    table.height(height);

    var box = $("<div>");
    box.addClass("gantt unselectable").attr("unselectable", "true").css({position:"relative", width:computedTableWidth});
    box.append(table);
    box.append(head);

    var getGanttId = this.master.ganttStore.id;
    let temp=80;
    if (location.href.includes('/wui/index.html')) {
      temp=140;
    }
    var svgDiv=$("<div>").addClass("gantSVGBoxDiv").height($(window).height()-temp-this.master.topHeight).width($('.splitBox2').width());
    svgDiv.scroll(e=>{
      var el = $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv');
      var top = el.scrollTop();
      var firstBox=$(`.TWGanttWorkSpace_${getGanttId}`).find('.splitBox1');
      firstBox.scrollTop(top);
      
      var left = el.scrollLeft();
      $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantt').find('.ganttFixHead').css('left', -left);
      $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantt').find('.ganttTable').css('margin-left', -left);
    });
    var svgDivContent=$("<div>").addClass("gantSVGBoxDivContent").width(computedTableWidth).height(height);
    svgDiv.append(svgDivContent);
    //create the svg
    svgDivContent.svg({settings:{class:"ganttSVGBox"},
      onLoad:         function (svg) {
        //console.debug("svg loaded", svg);
        //creates gradient and definitions
        var defs = svg.defs('myDefs');
        //create backgound
        var extDep = svg.pattern(defs, "extDep", 0, 0, 10, 10, 0, 0, 10, 10, {patternUnits:'userSpaceOnUse'});
        var img=svg.image(extDep, 0, 0, 10, 10, self.master.resourceUrl +"hasExternalDeps.png",{opacity:.3});
        self.svg = svg;
        $(svg).addClass("ganttSVGBox");
        //creates grid group
        var gridGroup = svg.group("gridGroup");
        //creates links group
        self.linksGroup = svg.group("linksGroup");
        //creates tasks group
        self.tasksGroup = svg.group("tasksGroup");
        //compute scalefactor fx
        //self.fx = computedTableWidth / (endPeriod - startPeriod);
        self.fx = zoomDrawer.computedScaleX;
      }
    });
    box.append(svgDiv);
    return box;
};

//拖动日期提示相关方法
Ganttalendar.prototype.createTaskBox=(taskbox,svg,taskBox)=>{
  var text = $(svg.text(parseInt(taskbox.attr("x")) + parseInt(taskbox.attr("width") + 8), parseInt(taskbox.attr("y"))+5, "", {"font-size":"10px","font-weight":"bold", "fill":"red"}));
  taskBox.data("textDur", text);
}

Ganttalendar.prototype.taskBoxShowText=(taskbox,taskBox,e,self,type)=>{
  var st = Math.round((parseFloat(taskbox.attr("x")) / self.fx) + self.startMillis);
  var en = Math.round(((parseFloat(taskbox.attr("x")) + parseFloat(taskbox.attr("width"))) / self.fx) + self.startMillis);
  var d ='';
  var text = taskBox.data("textDur");
  var x=parseFloat(taskbox.attr("x"));
  if(type=='0'){//向左
    d =new Date(st).format("yyyy-MM-dd HH:mm");
    x-=90;
  }else if(type=='1'){//向右
    d =new Date(en).format("yyyy-MM-dd HH:mm");
    x+=parseFloat(taskbox.attr("width"));
  }else if(type=='2'){//平移
    d =new Date(st).format("yyyy-MM-dd HH:mm")+ " - " +new Date(en).format("yyyy-MM-dd HH:mm") ;
  }
  text.attr("x",x).html(d);
}

Ganttalendar.prototype.removeTaskBox=(taskBox)=>{
  var textBox = taskBox.data("textDur");
  if (textBox)
    textBox.remove();
}

//<%-------------------------------------- GANT TASK GRAPHIC ELEMENT --------------------------------------%>
Ganttalendar.prototype.drawTask = function (task) {
  var self = this;

  var taskBoxs =_createTaskSVG(task);
  var taskBox=$(taskBoxs[0]);//计划时间
  var taskBox2=$(taskBoxs[1]);//实际时间
  task.ganttElement = taskBox;
  task.ganttElement2=taskBox2;
  if (self.showCriticalPath && task.isCritical)
    taskBox.addClass("critical");

  if (this.master.permissions.canWrite || task.canWrite) {
    //计划任务的拖拽事件
    taskBox.click(function (e) { // manages selection
        e.stopPropagation();// to avoid body remove focused
      }).dblclick(function () {}).mouseup(function (e) {
        self.master.ganttStore.ganttIsMouseDown=false;
      }).mousedown(function (e) {
        self.master.ganttStore.workSpaceClick(e)
        self.master.ganttStore.ganttIsMouseDown=true;
        self.master.ganttStore.closeTaskInfo();
      }).dragExtedSVG($(self.svg.root()), {
        canResize:this.master.permissions.canWrite || task.canWrite,
        canDrag:this.master.permissions.canWrite || task.canWrite,
        resizeZoneWidth:self.resizeZoneWidth,
        startDrag:function (e) {
          self.createTaskBox($(this),self.svg,taskBox);
        },
        drag:function (e) {
          self.taskBoxShowText($(this),taskBox,e,self,'2');
        },
        drop:function (e) {//平移结束回调函数
          self.removeTaskBox(taskBox);
          self.resDrop = true; //hack to avoid select
          var taskbox = $(this);
          var task = self.master.getTask(taskbox.attr("taskid"));
          var st = Math.round((parseFloat(taskbox.attr("x")) / self.fx) + self.startMillis);
          var en = Math.round(((parseFloat(taskbox.attr("x")) + parseFloat(taskbox.attr("width"))) / self.fx) + self.startMillis);
          //in order to avoid rounding issue if the movement is less than 1px we keep the same start and end dates
          if (Math.abs(st-task.start)<1/self.fx) {
            st = task.start;
          }
          if (Math.abs(en-task.end)<1/self.fx) {
            en = task.end;
          }
          task.start=st;
          task.end=en;
          self.master.afterModifiedTask(task,true);
          self.master.ganttStore.synchronizeGridEditor(task,'jh');
        },
        startResize:function (e) {//开始改变taskbox的宽度
          self.createTaskBox($(this),self.svg,taskBox);
        },
        resize:function (e,type) {//改变taskbox的宽度  type:0向左，1向右，2平移
          self.taskBoxShowText($(this),taskBox,e,self,type);
        },
        stopResize:function (e,type) {//结束改变taskbox的宽度
          self.removeTaskBox(taskBox);
          self.resDrop = true; //hack to avoid select
          var taskbox = $(this);
          var task = self.master.getTask(taskbox.attr("taskid"));
          var st = Math.round((parseFloat(taskbox.attr("x")) / self.fx) + self.startMillis);
          var en = Math.round(((parseFloat(taskbox.attr("x")) + parseFloat(taskbox.attr("width"))) / self.fx) + self.startMillis);
          //in order to avoid rounding issue if the movement is less than 1px we keep the same start and end dates
          if (Math.abs(st-task.start)<1/self.fx) {
            st = task.start;
          }
          if (Math.abs(en-task.end)<1/self.fx) {
            en = task.end;
          }
          task.start=st;
          task.end=en;
          //重绘svg图
          self.master.afterModifiedTask(task,true);
          self.master.ganttStore.synchronizeGridEditor(task,'jh');
        }
      });

    //实际任务的拖拽事件
    taskBox2.click(function (e) { // manages selection
      e.stopPropagation();// to avoid body remove focused
    }).dblclick(function () {

    }).mouseup(function (e) {
      self.master.ganttStore.ganttIsMouseDown=false;
    }).mousedown(function (e) {
      self.master.ganttStore.workSpaceClick(e)
      self.master.ganttStore.ganttIsMouseDown=true;
      self.master.ganttStore.closeTaskInfo();
    }).dragExtedSVG($(self.svg.root()), {
      canResize:  this.master.permissions.canWrite || task.canWrite,
      canDrag:    this.master.permissions.canWrite || task.canWrite,
      resizeZoneWidth:self.resizeZoneWidth,
      startDrag:function (e) {
        self.createTaskBox($(this),self.svg,taskBox);
      },
      drag:function (e) {
        self.taskBoxShowText($(this),taskBox,e,self,'2');
      },
      drop:function (e) {//平移结束回调函数
        self.removeTaskBox(taskBox);
        self.resDrop = true; //hack to avoid select
        var taskbox = $(this);
        var task = self.master.getTask(taskbox.attr("taskid"));
        var st = Math.round((parseFloat(taskbox.attr("x")) / self.fx) + self.startMillis);
        var en = Math.round(((parseFloat(taskbox.attr("x")) + parseFloat(taskbox.attr("width"))) / self.fx) + self.startMillis);
        //in order to avoid rounding issue if the movement is less than 1px we keep the same actualbegindate and actualenddate dates
        if (Math.abs(st-task.actualbegindate)<1/self.fx) {
          st = task.actualbegindate;
        }
        if (Math.abs(en-task.actualenddate)<1/self.fx) {
          en = task.actualenddate;
        }
        task.actualbegindate=st;
        task.actualenddate=en;
        self.master.afterModifiedTask(task,false);
        self.master.ganttStore.synchronizeGridEditor(task,'actual');
      },
      startResize:function (e,type) {//开始改变taskbox的宽度
        self.createTaskBox($(this),self.svg,taskBox);
      },
      resize:function (e,type) {//改变taskbox的宽度  type:0向左，1向右，2平移
        self.taskBoxShowText($(this),taskBox,e,self,type);
      },
      stopResize:function (e,type) {//结束改变taskbox的宽度
        self.removeTaskBox(taskBox);
        self.resDrop = true; //hack to avoid select
        var taskbox = $(this);
        var task = self.master.getTask(taskbox.attr("taskid"));
        var st = Math.round((parseFloat(taskbox.attr("x")) / self.fx) + self.startMillis);
        var en = Math.round(((parseFloat(taskbox.attr("x")) + parseFloat(taskbox.attr("width"))) / self.fx) + self.startMillis);
        //in order to avoid rounding issue if the movement is less than 1px we keep the same actualbegindate and actualenddate dates
        if (Math.abs(st-task.actualbegindate)<1/self.fx) {
          st = task.actualbegindate;
        }
        if (Math.abs(en-task.actualenddate)<1/self.fx) {
          en = task.actualenddate;
        }
        task.actualbegindate=st;
        task.actualenddate=en;
        //重绘svg图
        self.master.afterModifiedTask(task,false);
        self.master.ganttStore.synchronizeGridEditor(task,'actual');
      }
    });
  }
  taskBox.find("[class*=linkHandleSVG]").mousedown(function (e) {
    e.preventDefault();
    e.stopPropagation();
    var taskBox = $(this).closest(".taskBoxSVG");
    var svg = $(self.svg.root());
    var offs = svg.offset();
    self.linkOnProgress = true;
    self.linkFromEnd = $(this).is(".taskLinkEndSVG");
    svg.addClass("linkOnProgress");

    // create the line
    var startX = parseFloat(taskBox.attr("x")) + (self.linkFromEnd ? parseFloat(taskBox.attr("width")) : 0);
    var startY = parseFloat(taskBox.attr("y")) + parseFloat(taskBox.attr("height")) / 2;
    var line = self.svg.line(startX, startY, e.pageX - offs.left - 5, e.pageY - offs.top - 5, {class:"linkLineSVG"});
    var circle = self.svg.circle(startX, startY, 5, {class:"linkLineSVG"});

    //bind mousemove to draw a line
    svg.bind("mousemove.linkSVG", function (e) {
      var offs = svg.offset();
      var nx = e.pageX - offs.left;
      var ny = e.pageY - offs.top;
      var c = Math.sqrt(Math.pow(nx - startX, 2) + Math.pow(ny - startY, 2));
      nx = nx - (nx - startX) * 10 / c;
      ny = ny - (ny - startY) * 10 / c;
      self.svg.change(line, { x2:nx, y2:ny});
      self.svg.change(circle, { cx:nx, cy:ny});
    });

    //bind mouseup un body to stop
    $("body").one("mouseup.linkSVG", function (e) {
      $(line).remove();
      $(circle).remove();
      self.linkOnProgress = false;
      svg.removeClass("linkOnProgress");
      $(self.svg.root()).unbind("mousemove.linkSVG");
      var targetBox = $(e.target).closest(".taskBoxSVG");
      if (targetBox && targetBox.attr("taskid") != taskBox.attr("taskid")) {
        var taskTo;
        var taskFrom;
        if (self.linkFromEnd) {
          taskTo = self.master.getTask(targetBox.attr("taskid"));
          taskFrom = self.master.getTask(taskBox.attr("taskid"));
        } else {
          taskFrom = self.master.getTask(targetBox.attr("taskid"));
          taskTo = self.master.getTask(taskBox.attr("taskid"));
        }
        if (taskTo && taskFrom) {
          //权限判断
          if(!taskTo.canWrite){
            antd.message.warning('【'+taskTo.name+'】无编辑权限');
            return;
          }
          var getGanttId = self.master.ganttStore.id;
          $(`.TWGanttWorkSpace_${getGanttId}`).find("g[to=" + taskTo.id + "]").remove();
          taskTo.front=taskFrom.id;
          //更新links
          self.master.links=self.master.links.filter(item=>item.to.id!=taskTo.id);
          self.master.links.push({from:taskFrom,to:taskTo,lag:0});
          self.drawLink(taskFrom,taskTo);
          self.master.ganttStore.synchronizeGridEditorFront(taskFrom,taskTo);
        }
      }
    })
  });

  //prof.stop();

  function taskSVGMouseOver(e){
    var el = $(this);
    if (!self.linkOnProgress) {
      $("[class*=linkHandleSVG]").hide();
      if(!self.master.ganttStore.ganttIsMouseDown)el.find("[class*=linkHandleSVG]").stopTime("hideLink").show();
      if(e.srcElement&&e.srcElement.getAttribute('class')&&e.srcElement.getAttribute('class').indexOf('taskLayout')>-1){
        self.master.ganttStore.showTaskInfo({left:e.pageX,top:$(taskBox).offset().top,task});
      }
    } else {
      if(el.attr('status')=='STATUS_JH'){
        el.addSvgClass("linkOver");
      }
    }
  }
  function taskSVGMouseOut(e){
    var el = $(this);
    el.removeSvgClass("linkOver").find("[class*=linkHandleSVG]").oneTime(500,"hideLink",function(){$(this).hide()});
    if(e.relatedTarget&&e.relatedTarget.getAttribute('class')&&e.relatedTarget.getAttribute('class').indexOf('taskLayout')>-1){
      return;
    }
    self.master.ganttStore.closeTaskInfo();
  }

	function _createTaskSVG(task) {
    var svg = self.svg;
    var start=task.start;
    var end=task.end;
    var actualbegindate=task.actualbegindate;
    var actualenddate=task.actualenddate;
    var virtual_JH=false;
    if(!start&&!end){//如果开始日期和结束日期都为空，则取今天
      start=new Date().setHours(0, 0, 0, 0);
      end=new Date().setHours(23, 59, 59, 999);
      virtual_JH=true;
    }else if(end<=start){//如果开始日期大于结束日期，则取开始日期
      start=new Date(start);
      end=new Date(start).add('d',1);
      virtual_JH=true;
    }else if(!start&&end){
      start=new Date(end);
      end=new Date(end).add('d',-1);
      virtual_JH=true;
    }else if(start&&!end){
      start=new Date(start);
      end=new Date(start).add('d',1);
      virtual_JH=true;
    }
    var virtual_ACTUAL=false;
    if(!actualbegindate&&!actualenddate){
      actualbegindate=new Date().setHours(0, 0, 0, 0);
      actualenddate=new Date().setHours(23, 59, 59, 999);
      virtual_ACTUAL=true;
    }else if(actualenddate<=actualbegindate){
      actualbegindate=new Date(actualbegindate);
      actualenddate=new Date(actualbegindate).add('d',1);
      virtual_ACTUAL=true;
    }else if(!actualbegindate&&actualenddate){
      actualbegindate=new Date(actualenddate);
      actualenddate=new Date(actualenddate).add('d',-1);
      virtual_ACTUAL=true;
    }else if(actualbegindate&&!actualenddate){
      actualbegindate=new Date(actualbegindate);
      actualenddate=new Date(actualbegindate).add('d',1);
      virtual_ACTUAL=true;
    }

    var style_JH="";
    var style_ACTUAL="";
    if(self.master.ganttStore.datasColorMap[task.id]){
      style_JH='fill: '+self.master.ganttStore.datasColorMap[task.id].JH+';';
      if(virtual_JH){
        style_JH='fill: transparent;stroke-dasharray: 5;stroke-width:1;stroke:'+self.master.ganttStore.datasColorMap[task.id].JH+';';
      }
      style_ACTUAL='fill: '+self.master.ganttStore.datasColorMap[task.id].SJ+';';
      if(virtual_ACTUAL){
        style_ACTUAL='fill: transparent;stroke-dasharray: 5;stroke-width:1;stroke:'+self.master.ganttStore.datasColorMap[task.id].SJ+';';
      }
    }else{
      if(virtual_JH){
        style_JH='fill: transparent;stroke-dasharray: 5;stroke-width:1;';
      }
      if(virtual_ACTUAL){
        style_ACTUAL='fill: transparent;stroke-dasharray: 5;stroke-width:1;';
      }
    }


		var dimensions = {
      x     : Math.round((start - self.startMillis) * self.fx),
      x2:Math.round((actualbegindate - self.startMillis) * self.fx),
			y     : task.rowElement.position().top + task.rowElement.offsetParent().scrollTop() + self.taskVertOffset-60,
      width : Math.max(Math.round((end - start) * self.fx), 1),
      width2:Math.max(Math.round((actualenddate - actualbegindate) * self.fx), 1),
			height: self.taskHeight
    };
    //----------------------------------------------------------------------------------------------计划时间
    var taskSvg;

    taskSvg = svg.svg(self.tasksGroup, dimensions.x, dimensions.y, dimensions.width, dimensions.height, {class:"taskBox taskBoxSVG taskStatusSVG", status:'STATUS_JH', taskid:task.id});
    var layout = svg.rect(taskSvg, 0, 0, "100%", "100%", {class:"taskLayout",style:style_JH, rx:"2", ry:"2"});
    $(taskSvg).mouseover(taskSVGMouseOver);
    $(taskSvg).mouseout(taskSVGMouseOut);
    //task label
    svg.text(taskSvg, "100%", 18, task.name+'('+task.progress+'%)', {class:"taskLabelSVG", transform:"translate(20,-5)"});
    //link tool
    if(self.master.permissions.canWrite || task.canWrite){
      svg.circle(taskSvg, -self.resizeZoneWidth,  dimensions.height/2,dimensions.height/3, {class:"taskLinkStartSVG linkHandleSVG", transform:"translate("+(-dimensions.height/3+1)+")"});
    }
    svg.circle(taskSvg, dimensions.width+self.resizeZoneWidth,dimensions.height/2,dimensions.height/3, {class:"taskLinkEndSVG linkHandleSVG", transform:"translate("+(dimensions.height/3-1)+")"});
    //---------------------------------------------------------------------------------------------------实际时间
    var taskSvg2;
    taskSvg2 = svg.svg(self.tasksGroup, dimensions.x2, dimensions.y+10, dimensions.width2, dimensions.height, {class:"taskBox taskBoxSVG taskStatusSVG taskActualSVG", status:task.status, taskid:task.id });
    var layout2 = svg.rect(taskSvg2, 0, 0, "100%", "50%", {class:"taskLayout",style:style_ACTUAL, rx:"2", ry:"2"});
    $(taskSvg2).mouseover(taskSVGMouseOver);
    $(taskSvg2).mouseout(taskSVGMouseOut);
    return [taskSvg,taskSvg2];
  }

};


Ganttalendar.prototype.addTask = function (task,row,from) {
  if(from=='addNew'){//点击按钮新增时
    this.shrinkBoundaries(task);
    if(this.gridChanged&&this.isChangedBoundary()){//如果时间边界改变了需要重绘
      if(this.master.tasks.length>100){
        this.master.ganttStore.loadingtip='甘特图绘制中，请等待...';
        const _this=this;
        setTimeout(function(){
          _this.redraw();
        },100)
      }else{
        this.redraw();
      }
    }else{//如果没改变时间边界就不重绘，主要处理数据量大时重绘比较耗时的问题。
      var getGanttId = this.master.ganttStore.id;
      var workspace=$(`.TWGanttWorkSpace_${getGanttId}`);
      var gridGroup= workspace.find("#gridGroup").get(0);
      //甘特图最下边添加一行
      this.svg.rect(gridGroup, 0, this.master.editor.element.height(), "100%", this.master.rowHeight, {class: "ganttLinesSVG"});
      //延长甘特图的高度
      workspace.find('.gantSVGBoxDivContent').height(workspace.find('.gantSVGBoxDivContent').height()+this.master.rowHeight);
      workspace.find('.ganttTable').height(workspace.find('.ganttTable').height()+this.master.rowHeight);
      //将新行一下的所有任务往下移一格
      workspace.find('#tasksGroup').find('svg').each((index,item)=>{
        if(item.getAttribute('y')>row*this.master.rowHeight){
          item.setAttribute('y',parseInt(item.getAttribute('y'))+parseInt(this.master.rowHeight));
        }
      });
      this.drawTask(task);
      //前置关系横跨row上下的线需要重新绘制
      let links=this.master.links.filter(item=>{
        let fromRow=item.from.getRow();
        let toRow=item.to.getRow();
        if(fromRow>row){//大于row的原来task的原本的row都在现在的row基础上-1
          fromRow-=1;
        }
        if(toRow>row){
          toRow-=1;
        }
        return fromRow>=row&&toRow<=row||fromRow<=row&&toRow>=row||fromRow>=row&&toRow>=row;
      });
      links.forEach(item=>{
        $('g[id="'+item.from.id+'-'+item.to.id+'"]').remove();
      });
      links.forEach(link=>{
        this.drawLink(link.from, link.to);
      });
    }
    }
};

/**
 * 将甘特图的几行移动位置
 * @param {*} from 从第几行
 * @param {*} to   到第几行
 * @param {*} at   移动到这一行下边
 */
Ganttalendar.prototype.moveGantt = function (from,to,at) {
  var moveNum=to-from+1;//移动个数
  //获取第一部分数据
  var getGanttId = this.master.ganttStore.id;
  var workspace=$(`.TWGanttWorkSpace_${getGanttId}`);
  var firstDatas=workspace.find('#tasksGroup').find('svg').filter((index,item)=>{
    return item.getAttribute('y')>from*this.master.rowHeight&&item.getAttribute('y')<(to+1)*this.master.rowHeight;
  });
  const taskids = new Set();
  if(at>to){//上边的往下移 ,  分两步操作
    var beMoved=at-to;//被移动的个数
    var secondDatas=workspace.find('#tasksGroup').find('svg').filter((index,item)=>{
      return item.getAttribute('y')>(to+1)*this.master.rowHeight&&item.getAttribute('y')<(at+1)*this.master.rowHeight;
    });
    //第一步将to至at的所有行往上移动moveNum个高度
    secondDatas.each((index,item)=>{
      item.setAttribute('y',parseInt(item.getAttribute('y'))-moveNum*parseInt(this.master.rowHeight));
      taskids.add(item.getAttribute('taskid'));
    });
    //第二步将from至to的所有行往下移动secondDatas.length个高度
    firstDatas.each((index,item)=>{
      item.setAttribute('y',parseInt(item.getAttribute('y'))+beMoved*parseInt(this.master.rowHeight));
      taskids.add(item.getAttribute('taskid'));
    });
  }else{//下边的往上移
    var beMoved=from-at-1;//被移动的个数
    var secondDatas=workspace.find('#tasksGroup').find('svg').filter((index,item)=>{
      return item.getAttribute('y')>(at+1)*this.master.rowHeight&&item.getAttribute('y')<(from)*this.master.rowHeight;
    });
    //第一步将to至at的所有行往下移动moveNum个高度
    secondDatas.each((index,item)=>{
      item.setAttribute('y',parseInt(item.getAttribute('y'))+moveNum*parseInt(this.master.rowHeight));
      taskids.add(item.getAttribute('taskid'));
    });
    //第二步将from至to的所有行往上移动secondDatas.length个高度
    firstDatas.each((index,item)=>{
      item.setAttribute('y',parseInt(item.getAttribute('y'))-beMoved*parseInt(this.master.rowHeight));
      taskids.add(item.getAttribute('taskid'));
    });
  }
  //处理相关link
  taskids.forEach(taskid=>{
    this.redrawLink(this.master.getTask(taskid));
  });
}


//<%-------------------------------------- GANT DRAW LINK SVG ELEMENT --------------------------------------%>
//'from' and 'to' are tasks already drawn
Ganttalendar.prototype.drawLink = function (from, to, type) {
  //console.debug("drawLink")
  var self = this;
  var peduncolusSize = 10;

  /**
   * Given an item, extract its rendered position
   * width and height into a structure.
   */
  function buildRectFromTask(task) {

    var start=task.start;
    var end=task.end;
    if(!start&&!end){//如果开始日期和结束日期都为空，则取今天
      start=new Date().setHours(0, 0, 0, 0);
      end=new Date().setHours(23, 59, 59, 999);
    }else if(end<=start){//如果开始日期大于结束日期，则取开始日期
      start=new Date(start);
      end=new Date(start).add('d',1);
    }else if(!start&&end){
      start=new Date(end);
      end=new Date(end).add('d',-1);
    }else if(start&&!end){
      start=new Date(start);
      end=new Date(start).add('d',1);
    }

    var self=task.master.gantt;
    var editorRow = task.rowElement;
    var top = editorRow.position().top + editorRow.offsetParent().scrollTop();
    var x = Math.round((start - self.startMillis) * self.fx);
    var rect = {left: x, top: top + self.taskVertOffset, width: Math.max(Math.round((end - start) * self.fx),1), height: self.taskHeight};
    return rect;
  }

  /**
   * The default rendering method, which paints a start to end dependency.
   */
  function drawStartToEnd(from, to, ps) {
    var svg = self.svg;

    //this function update an existing link
    function update() {
      var group = $(this);
      var from = group.data("from");
      var to = group.data("to");

      var rectFrom = buildRectFromTask(from);
      var rectTo = buildRectFromTask(to);

      var fx1 = rectFrom.left;
      var fx2 = rectFrom.left + rectFrom.width;
      var fy = rectFrom.height / 2 + rectFrom.top-60;

      var tx1 = rectTo.left;
      var tx2 = rectTo.left + rectTo.width;
      var ty = rectTo.height / 2 + rectTo.top-60;


      var tooClose = tx1 < fx2 + 2 * ps;
      var r = 5; //radius
      var arrowOffset = 5;
      var up = fy > ty;
      var fup = up ? -1 : 1;

      var prev = fx2 + 2 * ps > tx1;
      var fprev = prev ? -1 : 1;

      var image = group.find("image");
      var p = svg.createPath();

      if (tooClose) {
        var firstLine = fup * (rectFrom.height / 2 - 2 * r + 2);
        p.move(fx2, fy)
          .line(ps, 0, true)
          .arc(r, r, 90, false, !up, r, fup * r, true)
          .line(0, firstLine, true)
          .arc(r, r, 90, false, !up, -r, fup * r, true)
          .line(fprev * 2 * ps + (tx1 - fx2), 0, true)
          .arc(r, r, 90, false, up, -r, fup * r, true)
          .line(0, (Math.abs(ty - fy) - 4 * r - Math.abs(firstLine)) * fup - arrowOffset, true)
          .arc(r, r, 90, false, up, r, fup * r, true)
          .line(ps, 0, true);
        image.attr({x:tx1 - 5, y:ty - 5 - arrowOffset});

      } else {
        p.move(fx2, fy)
          .line((tx1 - fx2) / 2 - r, 0, true)
          .arc(r, r, 90, false, !up, r, fup * r, true)
          .line(0, ty - fy - fup * 2 * r + arrowOffset, true)
          .arc(r, r, 90, false, up, r, fup * r, true)
          .line((tx1 - fx2) / 2 - r, 0, true);
        image.attr({x:tx1 - 5, y:ty - 5 + arrowOffset});
      }

      group.find("path").attr({d:p.path()});
    }


    // create the group
    var group = svg.group(self.linksGroup, "" + from.id + "-" + to.id);
    svg.title(group, from.name + " -> " + to.name);

    var p = svg.createPath();

    //add the arrow
    svg.image(group, 0, 0, 5, 10,"/formmode/e9resource/imgs/gantt/linkArrow.png");
    //create empty path
    svg.path(group, p, {class:"taskLinkPathSVG"});

    //set "from" and "to" to the group, bind "update" and trigger it
    var jqGroup = $(group).data({from:from, to:to }).attr({from:from.id, to:to.id}).on("update", update).trigger("update");

    if (self.showCriticalPath && from.isCritical && to.isCritical)
      jqGroup.addClass("critical");

    jqGroup.addClass("linkGroup");
    return jqGroup;
  }


  /**
   * A rendering method which paints a start to start dependency.
   */
  function drawStartToStart(from, to) {
    console.error("StartToStart not supported on SVG");
    var rectFrom = buildRectFromTask(from);
    var rectTo = buildRectFromTask(to);
  }

  var link;
  // Dispatch to the correct renderer
  if (type == 'start-to-start') {
    link = drawStartToStart(from, to, peduncolusSize);
  } else {
    link = drawStartToEnd(from, to, peduncolusSize);
  }

  // in order to create a dependency you will need permissions on both tasks
  if (this.master.permissions.canWrite || ( from.canWrite && to.canWrite)) {
    link.click(function (e) {
      var el = $(this);
      e.stopPropagation();// to avoid body remove focused
      self.element.find("[class*=focused]").removeClass("focused");
      $(".ganttSVGBox .focused").removeClass("focused");
      var el = $(this);
      if (!self.resDrop)
        el.addClass("focused");
      self.resDrop = false; //hack to avoid select

      $("body").off("click.focused").one("click.focused", function () {
        $(".ganttSVGBox .focused").removeClass("focused");
      })

    });
  }
};

Ganttalendar.prototype.redrawLink_taskids = function (taskids) {
  var collapsedDescendant = this.master.getCollapsedDescendant();
  var links=this.master.links.filter(item=>{
    if(collapsedDescendant.indexOf(item.from)>-1||collapsedDescendant.indexOf(item.to)>-1){//如果from或者to被收起这不绘link
      return false;
    }
    return taskids.has(item.from.id)||taskids.has(item.to.id);
  });

  links.forEach(item=>{
    $('g[id="'+item.from.id+'-'+item.to.id+'"]').remove();
  })

  for (var i = 0; i < links.length; i++) {
    var link = links[i];

    this.drawLink(link.from, link.to);
  }
};

Ganttalendar.prototype.redrawLink = function (task) {
  var collapsedDescendant = this.master.getCollapsedDescendant();
  var links=this.master.links.filter(item=>{
    if(collapsedDescendant.indexOf(item.from)>-1||collapsedDescendant.indexOf(item.to)>-1){//如果from或者to被收起这不绘link
      return false;
    }
    return item.from==task||item.to==task;
  });

  links.forEach(item=>{
    $('g[id="'+item.from.id+'-'+item.to.id+'"]').remove();
  })

  for (var i = 0; i < links.length; i++) {
    var link = links[i];

    this.drawLink(link.from, link.to);
  }
};

Ganttalendar.prototype.redrawLinks = function () {
  //console.debug("redrawLinks ");
  var self = this;
  this.element.stopTime("ganttlnksredr");
  this.element.oneTime(10, "ganttlnksredr", function () {
    //remove all links
    $("#linksGroup").empty();

    var collapsedDescendant = [];

    //[expand]
    var collapsedDescendant = self.master.getCollapsedDescendant();
    for (var i = 0; i < self.master.links.length; i++) {
      var link = self.master.links[i];

      if (collapsedDescendant.indexOf(link.from) >= 0 || collapsedDescendant.indexOf(link.to) >= 0) continue;


      self.drawLink(link.from, link.to);
    }
    self.master.ganttStore.afterInit();
  });
};


Ganttalendar.prototype.reset = function () {
  //var prof= new Profiler("ganttDrawerSVG.reset");
  this.element.find("[class*=linkGroup]").remove();
  this.element.find("[taskid]").remove();
  //prof.stop()
};


Ganttalendar.prototype.redrawTasks = function (drawAll) {
  //console.debug("redrawTasks ");
  var self=this;
  self.master.ganttStore.ganttIsMouseDown=false;
  var getGanttId = this.master.ganttStore.id;
  self.element.find("table.ganttTable").height(self.master.editor.element.height()+60);
  $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDivContent').height(self.master.editor.element.height());

  var collapsedDescendant = this.master.getCollapsedDescendant();

  $(`.TWGanttWorkSpace_${getGanttId}`).find("#linksGroup,#tasksGroup").empty();
  var gridGroup= $(`.TWGanttWorkSpace_${getGanttId}`).find("#gridGroup").empty().get(0);

  //add missing ones

  for (var i=0;i<self.master.tasks.length;i++){
    var task=self.master.tasks[i];
    if (collapsedDescendant.indexOf(task)>=0){
      continue;
    }

    this.drawTask(task);
    this.redrawLinks();
  }
  
  //creates rows grid
  for (var i = 0; i <= self.master.editor.element.height(); i += self.master.rowHeight)
    self.svg.rect(gridGroup, 0, i, "100%", self.master.rowHeight, {class: "ganttLinesSVG"});
  // drawTodayLine
  if (new Date().getTime() > self.startMillis && new Date().getTime() < self.endMillis) {
    var x = Math.round(((new Date().getTime()) - self.startMillis) * self.fx);
    self.svg.line(gridGroup, x, 0, x, "100%", {class: "ganttTodaySVG"});
  }
  $(`.TWGanttWorkSpace_${getGanttId}`).find('#gridGroup rect').click(e=>{
    var i=e.srcElement.getAttribute('y')/30;
    var currentTr=$("tr[data-taskid]:visible")[i];
    if(currentTr){
      currentTr.click();
    }
  });

  $(`.TWGanttWorkSpace_${getGanttId}`).find('#gridGroup rect').mouseover(e=>{
    var i=e.srcElement.getAttribute('y')/30;
    var currentTr=$("tr[data-taskid]:visible")[i];
    if(currentTr){
      self.master.editor.taskRowMouseOver($(currentTr));
    }
  });

  $(`.TWGanttWorkSpace_${getGanttId}`).find('#gridGroup rect').mouseout(e=>{
    var i=e.srcElement.getAttribute('y')/30;
    var currentTr=$("tr[data-taskid]:visible")[i];
    if(currentTr){
      self.master.editor.taskRowMouseOut($(currentTr));
    }
  });


  if(self.master.currentTask){
    var currentTaskTr=self.master.currentTask.rowElement[0];
    if(currentTaskTr&&$('.ganttLinesSVG')[currentTaskTr.sectionRowIndex]){
      $(`.TWGanttWorkSpace_${getGanttId}`).find('.ganttSVGSeletedRow').each((index,item)=>{
        item.setAttribute('class','ganttLinesSVG');
      });
      $(`.TWGanttWorkSpace_${getGanttId}`).find('.ganttLinesSVG')[currentTaskTr.sectionRowIndex].setAttribute('class','ganttSVGSeletedRow');
    }
  }

  //prof.stop();
};

//修改单个task数据时只要在根据当天task重新计算下边界即可
Ganttalendar.prototype.shrinkBoundaries = function (task) {
  //console.debug("shrinkBoundaries")
  var start = Infinity;
  var end =  -Infinity;
  var tasks=this.master.tasks;
  if(task){//如果是修改了单个任务的日期，原始边界不变在根据当前日期获取新边界
    tasks=[task];
    start=this.originalStartMillis;
    end=this.originalEndMillis;
  }
  for (var i = 0; i < tasks.length; i++) {
    var task = tasks[i];
    if(!task.start&&!task.actualbegindate){//如果都为空取今天
      var minStart=new Date().getTime();
      if (start > minStart)
      start = minStart;
    }else{//计划开始日期和实际开始日期不同时为空
      var minStart;
      if(!task.start){
        minStart=task.actualbegindate;
      }else if(!task.actualbegindate){
        minStart=task.start;
      }else{
        minStart=task.start>task.actualbegindate?task.actualbegindate:task.start;
      }
      if (start > minStart)
      start = minStart;
    }

    if(!task.end&&!task.actualenddate){//如果都为空取今天
      var maxEnd=new Date().getTime();
      if (end < maxEnd)
        end = maxEnd;
    }else{
      var maxEnd;
      if(!task.end){
        maxEnd=task.actualenddate;
      }else if(!task.actualenddate){
        maxEnd=task.end;
      }else{
        maxEnd=task.end>task.actualenddate?task.end:task.actualenddate;
      }

      if (end < maxEnd)
        end = maxEnd;
    } 

  }

  //if include today synch extremes
  if (this.includeToday) {
    var today = new Date().getTime();
    start = start > today ? today : start;
    end = end< today ? today : end;
  }

  //mark boundaries as changed
  this.gridChanged=this.gridChanged || this.originalStartMillis!=start || this.originalEndMillis!=end;

  this.originalStartMillis=start;
  this.originalEndMillis=end;
};

Ganttalendar.prototype.setBestFittingZoom = function () {

  //if zoom is not defined get the best fitting one
  var dur = this.originalEndMillis -this.originalStartMillis;
  var minDist = Number.MAX_VALUE;
  var i = 0;
  for (; i < this.zoomLevels.length; i++) {
    var dist = Math.abs(dur - millisFromString(this.zoomLevels[i]));
    if (dist <= minDist) {
      minDist = dist;
    } else {
      break;
    }
    this.zoom = this.zoomLevels[i];
  }

  this.zoom=this.zoom||this.zoomLevels[this.zoomLevels.length-1];

  //如果用户未设置时间轴，则自适应
  if(this.master.ganttStore.timelinekey==''){
    this.master.ganttStore.timelinekey=this.zoom;
  }
};

Ganttalendar.prototype.redraw = function () {

  if (this.showCriticalPath) {
    this.master.computeCriticalPath();
  }

  if (this.gridChanged) {
    this.gridChanged=false;
  var par = this.element.parent();
  var scrollDiv=$(`.TWGanttWorkSpace_${this.master.ganttStore.id}`).find('.gantSVGBoxDiv');

  //try to maintain last scroll
  var scrollY = scrollDiv.scrollTop();
  var scrollX = scrollDiv.scrollLeft();

  this.element.remove();

    var domEl = this.createGanttGrid();
  this.element = domEl;
  par.append(domEl);
  this.redrawTasks();

  //set old scroll  
  scrollDiv=$(`.TWGanttWorkSpace_${this.master.ganttStore.id}`).find('.gantSVGBoxDiv');
  scrollDiv.scrollTop(scrollY);
  scrollDiv.scrollLeft(scrollX);

  } else {
    this.redrawTasks();
  }
  this.master.ganttStore.loadingtip='';
};


Ganttalendar.prototype.fitGantt = function () {
  delete this.zoom;
  this.redraw();
};

Ganttalendar.prototype.getCenterMillis= function () {
  return parseInt((this.element.parent().scrollLeft()+this.element.parent().width()/2)/this.fx+this.startMillis);
};

Ganttalendar.prototype.goToMillis= function (millis) {
  var x = Math.round(((millis) - this.startMillis) * this.fx) -this.element.parent().width()/2;
  //this.element.parent().scrollLeft(x);
  var getGanttId = this.master.ganttStore.id;
  $(`.TWGanttWorkSpace_${getGanttId}`).find('.gantSVGBoxDiv').scrollLeft(x);
};

Ganttalendar.prototype.centerOnToday = function () {
  this.goToMillis(new Date().getTime());
};


/**
 * Allows drag and drop and extesion of task boxes. Only works on x axis
 * @param opt
 * @return {*}
 */
$.fn.dragExtedSVG = function (svg, opt) {

  //doing this can work with one svg at once only
  var target;
  var svgX;
  var offsetMouseRect;

  var options = {
    canDrag:        true,
    canResize:      true,
    resizeZoneWidth:5,
    minSize:        10,
    startDrag:      function (e) {},
    drag:           function (e) {},
    drop:           function (e) {},
    startResize:    function (e) {},
    resize:         function (e) {},
    stopResize:     function (e) {}
  };

  $.extend(options, opt);

  this.each(function () {
    var el = $(this);
    svgX = svg.parent().offset().left; //parent is used instead of svg for a Firefox oddity
    if (options.canDrag)
      el.addClass("deSVGdrag");
    if (options.canResize || options.canDrag) {
      el.bind("mousedown.deSVG",function (e) {
          if ($(e.target).is("image")) {
            e.preventDefault();
          }
          target = $(this);
          var x1 = parseFloat(el.find("[class*=taskLayout]").offset().left);
          var x2 = x1 + parseFloat(el.attr("width"));
          var posx = e.pageX;
          //start resize end
          if (options.canResize && Math.abs(posx-x2)<=options.resizeZoneWidth) {//向右resize
            //store offset mouse x2
            offsetMouseRect = x2 - e.pageX;
            target.attr("oldw", target.attr("width"));
            var one = true;
            //bind event for start resizing
            $(svg).bind("mousemove.deSVG", function (e) {
              $("[class*=linkHandleSVG]").hide();
              if (one) {
                //trigger startResize
                options.startResize.call(target.get(0), e);
                one = false;
              }
              //manage resizing
              var nW =  e.pageX - x1 + offsetMouseRect;
              target.attr("width", nW < options.minSize ? options.minSize : nW);
              //callback
              options.resize.call(target.get(0), e,'1');
            });
            //bind mouse up on body to stop resizing
            $("body").one("mouseup.deSVG", e=>{stopResize(e,'1')});
          //start resize start
          } else  if (options.canResize && Math.abs(posx-x1)<=options.resizeZoneWidth) {//向左resize
            //store offset mouse x1
            offsetMouseRect = parseFloat(target.attr("x"));
            target.attr("oldw", target.attr("width")); //todo controllare se è ancora usato oldw
            var one = true;
            //bind event for start resizing
            $(svg).bind("mousemove.deSVG", function (e) {
              $("[class*=linkHandleSVG]").hide();
              if (one) {
                //trigger startResize
                options.startResize.call(target.get(0), e);
                one = false;
              }
              //manage resizing
              var nx1= offsetMouseRect-(posx-e.pageX);
              var nW = (x2-x1) + (posx-e.pageX);
              nW=nW < options.minSize ? options.minSize : nW;
              target.attr("x",nx1);
              target.attr("width", nW);
              //callback
              options.resize.call(target.get(0), e,'0');
            });
            //bind mouse up on body to stop resizing
            $("body").one("mouseup.deSVG", e=>{stopResize(e,'0')});
            // start drag
          } else if (options.canDrag) {//平移
            //store offset mouse x1
            offsetMouseRect = parseFloat(target.attr("x")) - e.pageX;
            target.attr("oldx", target.attr("x"));
            var one = true;
            //bind event for start dragging
            $(svg).bind("mousemove.deSVG",function (e) {
              //hide link circle
              $("[class*=linkHandleSVG]").hide();
              if (one) {
                //trigger startDrag
                options.startDrag.call(target.get(0), e);
                one = false;
              }
              //manage resizing
              target.attr("x", offsetMouseRect + e.pageX);
              //callback
              options.drag.call(target.get(0), e);
            }).bind("mouseleave.deSVG", drop);
            //bind mouse up on body to stop resizing
            $("body").one("mouseup.deSVG", drop);
          }
        }
      ).bind("mousemove.deSVG",  //控制鼠标移动到taskbox上的鼠标样式
        function (e) {
          var el = $(this);
          var x1 = el.find("[class*=taskLayout]").offset().left;
          var x2 = x1 + parseFloat(el.attr("width"));
          var posx = e.pageX;
          if (options.canResize && (Math.abs(posx-x1)<=options.resizeZoneWidth || Math.abs(posx-x2)<=options.resizeZoneWidth)) {
            el.addSvgClass("deSVGhand");
            el.removeSvgClass("deSVGdrag");
          } else {
            el.addSvgClass("deSVGdrag");
            el.removeSvgClass("deSVGhand");
          }
        }
      ).addClass("deSVG");
    }
  });
  return this;


  function stopResize(e,type) {
    $(svg).unbind("mousemove.deSVG").unbind("mouseup.deSVG").unbind("mouseleave.deSVG");
    if (target && target.attr("oldw")!=target.attr("width"))
      options.stopResize.call(target.get(0), e,type); //callback
    target = undefined;
  }

  function drop(e,type) {
    $(svg).unbind("mousemove.deSVG").unbind("mouseup.deSVG").unbind("mouseleave.deSVG");
    if (target && target.attr("oldx") != target.attr("x"))
      options.drop.call(target.get(0), e,type); //callback
    target = undefined;
  }

};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/lib/gantt/js/ganttDrawerSVG.js